import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateSchedulesCreatePricingControllerModule } from './controllers/TemplatesCreateSchedulesCreatePricingController';

export const TemplatesCreateSchedulesCreatePricingView = angular
  .module('acme.view.application.templates.create.schedules.create.pricing', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateSchedulesCreatePricingControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.templates.create.schedules.create.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreatePricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Schedule Pricing',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.create.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreatePricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Pricing',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.edit.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreatePricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Pricing',
      },
    });
  }).name;
